export const LabelMap = {
    new: 'New',
    upcoming: 'Upcoming',
    content: 'Content'

};
